package com.mps.asc_app.firebase

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize

actual object FirebaseInitializer {
    actual fun initialize() {
        val options = FirebaseOptions(
            applicationId = "1:93472406808:web:fd1518eb43298f8b22f26d",
            apiKey = "AIzaSyAhg8Q9KJJq5oRWIV790xgT2v47VGSsn4M",
            projectId = "asc-cranz-estebruegge",
            storageBucket = "asc-cranz-estebruegge.firebasestorage.app",
            gcmSenderId = "93472406808"
        )

        val result = runCatching {
            Firebase.initialize(Unit, options)
        }

        if (result.isFailure) {
            val message = result.exceptionOrNull()?.message.orEmpty()
            val isDuplicateInit =
                message.contains("already", ignoreCase = true) ||
                message.contains("duplicate", ignoreCase = true)
            if (!isDuplicateInit) {
                throw result.exceptionOrNull() ?: IllegalStateException("Firebase init failed")
            }
        }
    }
}